<template>
  <div class="artists">
    <div class="artists__header">
      <h1 class="artists__header_title">Creators</h1>
    </div>

    <div v-if="sortedArtistsList.length > 0" class="artists__body">
      <div
        v-for="(column, index) in sortedArtistsList"
        :key="`column-${index}`"
        class="artists__body__column"
      >
        <router-link
          v-for="(item, index) in column"
          :key="`item-${index}`"
          class="artists__body__column_item"
          :to="{
            name: 'ArtistProfile',
            params: { slug: item.slug, name: `${item.first_name} ${item.last_name}` },
          }"
        >
          <span class="artists__body__column_name">
            {{ item.last_name }}, {{ item.first_name }} ({{ item.artworks_count }})
          </span>
        </router-link>
      </div>
    </div>

    <div class="navigation__container">
      <span class="navigation__container_title">View: Collection</span>
      <div class="navigation__container_buttons-box">
        <BaseButton
          class="button--white button--oval"
          text="Collection"
          @click.native="goToPage('/art/collection')"
        />

        <BaseButton
          class="button--outline-white button--oval"
          text="Back to Home"
          @click.native="goToPage('/')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { sortedColumns } from "@/helper.js";
import { mapGetters, mapActions, mapMutations } from "vuex";
import BaseButton from "@/components/buttons/BaseButton.vue";

export default {
  components: { BaseButton },

  data() {
    return {
      sortedArtistsList: [],
    };
  },

  head: {
    title: function () {
      return {
        inner: "GH - Creators",
        separator: " ",
        complement: " ",
      };
    },
    meta: function () {
      return [];
    },
  },

  computed: {
    ...mapGetters("publicArtists", {
      artistsList: "getArtistsList",
    }),

    getColumnsAmount() {
      const width = window.innerWidth;

      if (width < 540) {
        return 1;
      } else if (width < 768) {
        return 2;
      } else if (width < 1024) {
        return 3;
      } else {
        return 4;
      }
    },
  },

  async created() {
    await this.apiGetArtistsList();
    this.sortedArtistsList = sortedColumns(this.artistsList, this.getColumnsAmount); //to get columns

    const breadcrumbs = [
      {
        title: "Home",
        to: "/",
      },
      {
        title: "Creators",
        to: "/creators",
      },
    ];
    this.setBreadcrumbs(breadcrumbs);
  },

  methods: {
    ...mapActions("publicArtists", ["apiGetArtistsList"]),
    ...mapMutations(["setBreadcrumbs"]),

    goToPage(page) {
      this.$router.push({ path: page });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  color: $white;
}

.artists {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $lightBlack;
  min-height: 100vh;
  min-width: 100vw;
  font-size: 2.1rem;
  line-height: 3.5rem;
  @media only screen and (max-width: $xxs) {
    font-size: 1.8rem;
    line-height: 2.8rem;
  }

  &__header {
    margin-top: 15.6rem;
    @media only screen and (max-width: $xxs) {
      margin-top: 28.3rem;
      padding: 0rem 2.8rem;
    }

    &_title {
      display: inline-block;
      text-align: center;
      font-family: $fontBodoni;
      font-size: 6.2rem;
      line-height: 6.8rem;
      @media only screen and (max-width: $xxs) {
        font-size: 4rem;
        line-height: 6rem;
      }
    }
  }

  &__body {
    display: flex;
    justify-content: space-between;
    width: 85%;
    margin-top: 140px;
    @media only screen and (max-width: $xs) {
      width: 100%;
      margin-top: 6.7rem;
      display: block;
      text-align: center;
    }

    &__column {
      &_item {
        display: block;
        text-decoration: none;
      }

      &_name {
        font-size: 2.1rem;
        line-height: 3.5rem;
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

  .navigation__container {
    display: flex;
    flex-direction: column;
    margin: 16.5rem 0rem 10.4rem;
    padding-left: 30%;
    width: 100%;
    @media only screen and (max-width: $xs) {
      padding-left: 15%;
    }
    @media only screen and (max-width: $xxs) {
      margin: 9.3rem 0rem 18.9rem;
      padding-left: 2.6rem;
    }
    &_title {
      font-size: 3.8rem;
      line-height: 4.8rem;
      margin: 0rem 0rem 5rem 1.2rem;
      font-family: $fontBodoni;
      @media only screen and (max-width: $xxs) {
        font-size: 2.4rem;
        line-height: 3rem;
        margin: 0rem 0rem 3rem 0rem;
      }
    }
    &_buttons-box {
      display: flex;
      align-items: center;
      @media only screen and (max-width: $sm) {
        flex-wrap: wrap;
      }
      &::after {
        content: "";
        background-color: $white;
        height: 1px;
        flex-grow: 100;
      }
      .button--oval {
        margin-left: 12px;
        font-family: $fontBodoni;
        @media only screen and (max-width: $sm) {
          margin-left: 0px;
          padding: 12px 18px;
        }
      }
      @media only screen and (max-width: $sm) {
        .button--white {
          width: 60%;
        }
        .button--outline-white {
          margin-top: 1.8rem;
        }
      }
    }
  }
}
</style>

